var _path, _path2, _circle, _circle2, _circle3, _circle4;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgResidentialProxies(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.55,
    d: "M19.733 1c10.346 0 18.733 8.387 18.733 18.733s-8.387 18.733-18.733 18.733S1 30.079 1 19.733 9.387 1 19.733 1z",
    stroke: "#525376",
    strokeWidth: 1.873,
    strokeDasharray: "1.87 1.87"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.55,
    d: "M19.733 4.747c8.277 0 14.987 6.71 14.987 14.986 0 8.277-6.71 14.986-14.986 14.986-8.277 0-14.987-6.71-14.987-14.986 0-8.277 6.71-14.986 14.986-14.986z",
    stroke: "#525376",
    strokeWidth: 1.873,
    strokeDasharray: "1.87 1.87"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 33.38,
    cy: 6.62,
    r: 4.683,
    fill: "#525376",
    stroke: "#33345E",
    strokeWidth: 1.873
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 6.62,
    cy: 31.509,
    r: 4.683,
    fill: "#525376",
    stroke: "#33345E",
    strokeWidth: 1.873
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 6.62,
    cy: 6.62,
    r: 4.683,
    fill: "#9394B4",
    stroke: "#656793",
    strokeWidth: 1.873
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 33.38,
    cy: 31.509,
    r: 4.683,
    fill: "#9394B4",
    stroke: "#656793",
    strokeWidth: 1.873
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDAiIGhlaWdodD0iNDAiIHZpZXdCb3g9IjAgMCA0MCA0MCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggb3BhY2l0eT0iMC41NSIgZD0iTTE5LjczMjkgMUMzMC4wNzg4IDEgMzguNDY1OCA5LjM4NzAxIDM4LjQ2NTggMTkuNzMyOUMzOC40NjU4IDMwLjA3ODggMzAuMDc4OCAzOC40NjU4IDE5LjczMjkgMzguNDY1OEM5LjM4NzAxIDM4LjQ2NTggMSAzMC4wNzg4IDEgMTkuNzMyOUMxIDkuMzg3MDEgOS4zODcwMSAxIDE5LjczMjkgMVoiIHN0cm9rZT0iIzUyNTM3NiIgc3Ryb2tlLXdpZHRoPSIxLjg3MzI5IiBzdHJva2UtZGFzaGFycmF5PSIxLjg3IDEuODciLz4KPHBhdGggb3BhY2l0eT0iMC41NSIgZD0iTTE5LjczMzUgNC43NDY1OEMyOC4wMTAyIDQuNzQ2NTggMzQuNzE5OCAxMS40NTYyIDM0LjcxOTggMTkuNzMyOUMzNC43MTk4IDI4LjAwOTYgMjguMDEwMiAzNC43MTkyIDE5LjczMzUgMzQuNzE5MkMxMS40NTY4IDM0LjcxOTIgNC43NDcxNCAyOC4wMDk2IDQuNzQ3MTQgMTkuNzMyOUM0Ljc0NzE0IDExLjQ1NjIgMTEuNDU2OCA0Ljc0NjU4IDE5LjczMzUgNC43NDY1OFoiIHN0cm9rZT0iIzUyNTM3NiIgc3Ryb2tlLXdpZHRoPSIxLjg3MzI5IiBzdHJva2UtZGFzaGFycmF5PSIxLjg3IDEuODciLz4KPGNpcmNsZSBjeD0iMzMuMzgwMyIgY3k9IjYuNjE5ODciIHI9IjQuNjgzMjMiIGZpbGw9IiM1MjUzNzYiIHN0cm9rZT0iIzMzMzQ1RSIgc3Ryb2tlLXdpZHRoPSIxLjg3MzI5Ii8+CjxjaXJjbGUgY3g9IjYuNjE5ODciIGN5PSIzMS41MDkzIiByPSI0LjY4MzIzIiBmaWxsPSIjNTI1Mzc2IiBzdHJva2U9IiMzMzM0NUUiIHN0cm9rZS13aWR0aD0iMS44NzMyOSIvPgo8Y2lyY2xlIGN4PSI2LjYxOTg3IiBjeT0iNi42MTk4NyIgcj0iNC42ODMyMyIgZmlsbD0iIzkzOTRCNCIgc3Ryb2tlPSIjNjU2NzkzIiBzdHJva2Utd2lkdGg9IjEuODczMjkiLz4KPGNpcmNsZSBjeD0iMzMuMzgwMyIgY3k9IjMxLjUwOTMiIHI9IjQuNjgzMjMiIGZpbGw9IiM5Mzk0QjQiIHN0cm9rZT0iIzY1Njc5MyIgc3Ryb2tlLXdpZHRoPSIxLjg3MzI5Ii8+Cjwvc3ZnPgo=";
export { SvgResidentialProxies as ReactComponent };